import {
  AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChildren,
  ViewEncapsulation
} from '@angular/core';

import { v4 as uuid } from 'uuid';
import { TranslateModule } from '@ngx-translate/core';

import { IconSizeEnum, SdIconComponent, SdListComponent } from '@seb/web-design-system/core';

import type { IMapLegend } from './map-legend.interface';

@Component({
  selector: 'sd-map-legend',
  templateUrl: './map-legend.component.html',
  styleUrls: ['./map-legend.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SdListComponent, SdIconComponent, TranslateModule]
})
export class SdMapLegendComponent implements AfterViewInit, OnInit {
  constructor(private renderer: Renderer2) {}
  iconSize = IconSizeEnum.large;

  @Input()
  legends: IMapLegend[];

  @ViewChildren('mapLegends', { read: ElementRef })
  mapLegends: QueryList<ElementRef>;

  ngOnInit() {
    for (const legend of this.legends) {
      legend.id = uuid();
    }
  }

  ngAfterViewInit() {
    let mapLegendEl: ElementRef;

    for (const legend of this.legends) {
      if (legend.color) {
        mapLegendEl = this.mapLegends.toArray().filter((el) => {
          return el.nativeElement.id === legend.id;
        })[0];
        this.renderer.setStyle(mapLegendEl.nativeElement, 'fill', legend.color);
      }
    }
  }
}
